class BotChallengeError extends Error {
  constructor() {
    super('Bot Challenge');
  }
}

export { BotChallengeError };
